import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import HolidayPopUp from "./holiday_popup.js";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const HolidayAccept = (props) => {
  const [showHolidayPopUp, setShowHolidayPopUp] = useState(false);
  const [holiday, setHoliday] = useState(null);
  const [holidaysData, setHolidaysData] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [loading, setLoading] = useState(true);

  const openHolidayPopUp = (e) => {
    setShowHolidayPopUp(true);
    var value = e.currentTarget.attributes.value.nodeValue;

    setHoliday(holidaysData.filter((el) => +el.id === +value)[0]);
  };

  const closeHolidayPopUp = (e) => {
    setShowHolidayPopUp(false);
    setHoliday(null);
    getData();
  };

  const fetchHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidaysData(data);
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const getData = () => {
    setLoading(true);
    fetchHolidays();
  };

  useEffect(() => {
    getData();
  }, []);

  const reportedHolidayData = (
    <>
      <table className="holidays_table" id="holidays_table_reported">
        <tr key={0}>
          <th>ID</th>
          <th>Data od</th>
          <th>Data do</th>
          <th>Data dodania</th>
        </tr>
        {holidaysData
          .filter((el) => el.status === "REPORTED" && el.type === "holiday")
          .map((el) => (
            <>
              <tr key={el.id}>
                <td value={el.id} onClick={openHolidayPopUp}>
                  {el.id}
                </td>
                <td value={el.id} onClick={openHolidayPopUp}>
                  {el.date_from}
                </td>
                <td value={el.id} onClick={openHolidayPopUp}>
                  {el.date_to}
                </td>
                <td value={el.id} onClick={openHolidayPopUp}>
                  {new Date(el.date_added).getFullYear() +
                    "-" +
                    (new Date(el.date_added).getMonth() + 1 < 10
                      ? "0" + (new Date(el.date_added).getMonth() + 1)
                      : new Date(el.date_added).getMonth() + 1) +
                    "-" +
                    new Date(el.date_added).getDate()}
                </td>
              </tr>
            </>
          ))}
      </table>
    </>
  );

  const calendarMonthNew = (
    <>
      <div className="holidaysBox">
        <p className="holidayTitle">WNIOSKI URLOPOWE DO AKCEPTACJI</p>
        {reportedHolidayData}
      </div>
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          {showHolidayPopUp ? (
            <HolidayPopUp
              close={closeHolidayPopUp}
              holiday={holiday}
              holidaysSheetData={props.holidaysSheetData}
              holidaysBlockData={props.holidaysBlockData}
              refreshData={props.refreshData}
              users={props.users}
              user={props.user}
              mode="admin"
              team={props.team}
              holidaysData={holidaysData}
            />
          ) : (
            <div className="mainContainerCalendar">
              <div className="closeBox">
                <button className="closeClientButton" onClick={props.close}>
                  X
                </button>
              </div>
              {calendarMonthNew}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default HolidayAccept;
